import { useQuery, useQueryClient, keepPreviousData } from "@tanstack/react-query";
import { QUERIES_KEYS } from "queries";
import { ksefApi } from "./ksefApi";

export const useKsefIntegration = (id: number) => {
  const queryClient = useQueryClient();
  const { isLoading, isFetching, data } = useQuery({
    queryKey: QUERIES_KEYS.KSEF_INTEGRATION_BY_ID(id),
    queryFn: () => ksefApi.fetchById(id),
    placeholderData: keepPreviousData,
    enabled: id > 0,
  });

  const invalidate = () => {
    queryClient.invalidateQueries({ queryKey: QUERIES_KEYS.KSEF_INTEGRATION_BY_ID(id) });
  };

  return { invalidate, isLoading, isFetching, integration: data?.data };
};
